import React from 'react';
import { Button } from '@/components/ui/button';
import { CardFooter, CardDescription } from '@/components/ui/card';
import { useN8nStatus } from '@/hooks/use-n8n-status';
import { Loader2, Rocket, Check } from 'lucide-react';
import { StepLayout } from '../StepLayout';

interface WelcomeStepProps {
  onNext: (data: Record<string, any>) => void;
  data?: Record<string, any>;
  isLastStep?: boolean;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext, data = {} }) => {
  const n8nStatus = useN8nStatus();
  
  const handleContinue = () => {
    onNext({ completed: true });
  };

  // Tela de aguardo enquanto n8n não está configurado
  if (!n8nStatus.isReady && !data.forceShow) {
    return (
      <StepLayout
        title="Preparando seu ambiente..."
        description="Estamos configurando tudo para você ter a melhor experiência!"
        icon={<Loader2 className="h-5 w-5 animate-spin" />}
      >
        <div className="space-y-6 text-center py-8">
          <div className="flex justify-center">
            <Loader2 className="h-16 w-16 animate-spin text-primary" />
          </div>
          <div className="space-y-4">
            <p className="text-lg">
              Nossos robôs estão trabalhando nos bastidores para preparar sua conta.
            </p>
            <p>
              Isso pode levar alguns instantes... Aproveite para tomar um café ☕
            </p>
            <p className="text-sm text-muted-foreground">
              (Este é um ótimo momento para conferir as configurações do n8n em sua conta)
            </p>
          </div>
          <div className="pt-4">
            <Button variant="outline" onClick={() => window.location.href = '/dashboard/n8n-integration'}>
              Verificar configurações do n8n
            </Button>
          </div>
        </div>
      </StepLayout>
    );
  }

  // Tela normal de boas-vindas após n8n configurado
  return (
    <StepLayout
      title="Bem-vindo ao Zapcore!"
      description="Vamos configurar sua conta para você começar a utilizar o sistema."
      icon={<Rocket className="h-5 w-5" />}
    >
      <div className="space-y-6 py-4">
        <p className="text-center">
          O assistente de configuração vai te ajudar a configurar:
        </p>
        
        <div className="space-y-2 max-w-md mx-auto">
          {[
            "Conexão com WhatsApp",
            "Informações do seu negócio",
            "Assistente de IA personalizado",
            "Agendamentos",
            "Produtos e serviços"
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-2 p-2 rounded-md bg-muted/40">
              <div className="bg-primary/10 rounded-full p-1">
                <Check className="h-4 w-4 text-primary" />
              </div>
              <span>{item}</span>
            </div>
          ))}
        </div>
        
        <p className="text-center text-muted-foreground mt-4">
          O processo deve levar apenas alguns minutos.
        </p>
        
        <div className="flex justify-center pt-4">
          <Button size="lg" onClick={handleContinue} className="px-8">
            Começar configuração
          </Button>
        </div>
      </div>
    </StepLayout>
  );
}; 